import { __assign, __spreadArray } from 'tslib';
import React__default from 'react';
import { fetcherModeAtom, FetcherMode, ActionValue } from '@keepeek/commons';
import { useTheme, useMediaQuery, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import KButton from '../../KButtons/index.js';
import KButtonAction from '../../KButtons/KButtonAction/index.js';
import { generateButtonSx, generateDisabledButtonSx } from '../../utils/buttonStyle.js';
import { ActionDisplayType, actionList } from './constants.js';
import { isActionVisible } from './utils.js';

var ButtonDisplay = function ButtonDisplay(_a) {
    var onActionClick = _a.onActionClick, _b = _a.onActionMouseEnter, onActionMouseEnter = _b === void 0 ? function () { } : _b, isSelection = _a.isSelection, isBasket = _a.isBasket, selectedElements = _a.selectedElements, enabled = _a.enabled, KIcon = _a.KIcon, isShare = _a.isShare, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, contactSheetsEnabled = _a.contactSheetsEnabled, enabledActions = _a.enabledActions, actionButtonsColor = _a.actionButtonsColor;
    var t = useTranslation("refront-components").t;
    var theme = useTheme();
    var contactSheetActionButton = {
        labelKey: "components.dataview.action.contact-sheets.label",
        testId: "contactSheetsButton",
        icon: "fa-solid fa-file-pdf",
        value: ActionValue.CONTACT_SHEETS,
        showForBasket: true,
        showForShare: false,
        showForOneElement: true,
        showForManyElement: true,
        hidden: !contactSheetsEnabled
    };
    var completeActionList = __spreadArray(__spreadArray([], actionList, true), [contactSheetActionButton], false);
    var isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
    return (React__default.createElement(React__default.Fragment, null, completeActionList.map(function (action) {
        var _a;
        return isActionVisible({
            isSelection: isSelection,
            isBasket: isBasket,
            isShare: isShare,
            action: action,
            shareTokenDownloadAuthorized: shareTokenDownloadAuthorized,
            enabledActions: enabledActions
        }) && (React__default.createElement(KButton, { key: action.labelKey, testId: action.testId, color: "primary", size: "small", sx: __assign((_a = {}, _a[theme.breakpoints.down("sm")] = {
                flex: 1,
                span: {
                    margin: 0
                }
            }, _a.marginRight = 1, _a), (enabled
                ? generateButtonSx({
                    buttonStyle: actionButtonsColor,
                    theme: theme
                })
                : generateDisabledButtonSx(actionButtonsColor))), startIcon: React__default.createElement(KIcon, { className: action.icon }), buttonName: action.value, disabled: !enabled, onClick: function () {
                onActionClick(action.value);
            }, onMouseEnter: function () { return onActionMouseEnter(action.value); } }, !isSmDown && t(action.labelKey, { count: selectedElements.length })));
    })));
};
var MenuDisplay = function MenuDisplay(_a) {
    var onActionClick = _a.onActionClick, _b = _a.onActionMouseEnter, onActionMouseEnter = _b === void 0 ? function () { } : _b, isSelection = _a.isSelection, isBasket = _a.isBasket, selectedElements = _a.selectedElements, enabled = _a.enabled, KIcon = _a.KIcon, isShare = _a.isShare, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, enabledActions = _a.enabledActions;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(React__default.Fragment, null, actionList.map(function (action) {
        return isActionVisible({
            isSelection: isSelection,
            isBasket: isBasket,
            isShare: isShare,
            action: action,
            shareTokenDownloadAuthorized: shareTokenDownloadAuthorized,
            enabledActions: enabledActions
        }) && (React__default.createElement(MenuItem, { key: action.labelKey, disabled: !enabled, onClick: function () {
                onActionClick(action.value);
            }, onMouseEnter: function () { return onActionMouseEnter(action.value); } },
            React__default.createElement(ListItemIcon, null,
                React__default.createElement(KIcon, { className: action.icon })),
            React__default.createElement(ListItemText, { primary: t(action.labelKey, { count: selectedElements.length }) })));
    })));
};
var ActionButtonDisplay = function ActionButtonDisplay(_a) {
    var onActionClick = _a.onActionClick, _b = _a.onActionMouseEnter, onActionMouseEnter = _b === void 0 ? function () { } : _b, isSelection = _a.isSelection, isBasket = _a.isBasket, isRichElement = _a.isRichElement, selectedElements = _a.selectedElements, enabled = _a.enabled, KIcon = _a.KIcon, isShare = _a.isShare, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, enabledActions = _a.enabledActions;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(React__default.Fragment, null, actionList.map(function (action) {
        return isActionVisible({
            isSelection: isSelection,
            isBasket: isBasket,
            isShare: isShare,
            action: action,
            shareTokenDownloadAuthorized: shareTokenDownloadAuthorized,
            isRichElement: isRichElement,
            enabledActions: enabledActions
        }) && (React__default.createElement(KButtonAction, { size: "small", key: action.labelKey, disabled: !enabled, onClick: function () {
                onActionClick(action.value);
            }, onMouseEnter: function () { return onActionMouseEnter(action.value); }, actionButtonName: action.value, "aria-label": t(action.labelKey, { count: selectedElements.length }), title: t(action.labelKey, { count: selectedElements.length }) },
            React__default.createElement(KIcon, { fontSize: "small", className: action.icon })));
    })));
};
var Actions = function Actions(props) {
    var enabled = !props.isSelection || props.selectedElements.length > 0;
    var fetcherMode = useRecoilValue(fetcherModeAtom);
    var isShare = fetcherMode === FetcherMode.SHARE;
    switch (props.displayType) {
        case ActionDisplayType.BUTTON:
            return React__default.createElement(ButtonDisplay, __assign({}, props, { enabled: enabled, isShare: isShare }));
        case ActionDisplayType.MENU:
            return React__default.createElement(MenuDisplay, __assign({}, props, { enabled: enabled, isShare: isShare }));
        case ActionDisplayType.ACTION_BUTTON:
            return React__default.createElement(ActionButtonDisplay, __assign({}, props, { enabled: enabled, isShare: isShare }));
        default:
            throw new Error("this display type ".concat(props.displayType, " is not implemented"));
    }
};

export { Actions as default };
//# sourceMappingURL=index.js.map
